import React, { useState } from "react";
import {
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { formatDate } from "../../utils";
import { useRiskFactorDates } from "../../hooks/useRiskFactorDates";
import { useRiskFactorData } from "../../hooks/useRiskFactorData";
import RiskFactorShow from "./RiskFactorShow";
import RiskFactorIntake from "./RiskFactorIntake";

const Risks = ({ patient_id }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [isIntake, setIsIntake] = useState(false);

  const {
    data: riskFactorDates,
    isLoading: datesLoading,
    isError: datesError,
  } = useRiskFactorDates(patient_id);
  const {
    data: riskFactorData,
    isLoading: dataLoading,
    isError: dataError,
  } = useRiskFactorData(patient_id, selectedDate);

  if (datesLoading) return <h3>Loading dates…</h3>;
  if (datesError) return <h3>Failed to load dates.</h3>;

  const handleBack = () => {
    setIsIntake(false);
    setSelectedDate("");
  };

  const selectPanel = (
    <div className="card">
      <h2>Select a Date to View Risk Factors</h2>

      <Box display="flex" alignItems="center" mb={2} gap={2}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="rf-date-select-label">Date</InputLabel>
          <Select
            size="small"
            labelId="rf-date-select-label"
            value={selectedDate}
            label="Date"
            onChange={(e) => setSelectedDate(e.target.value)}
          >
            {riskFactorDates.map((date) => (
              <MenuItem key={date} value={date}>
                {formatDate(date)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ ml: "auto" }}>
          <Button
            variant="outlined"
            onClick={() => setIsIntake(true)}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Risk Factor Intake
          </Button>
        </Box>
      </Box>

      {selectedDate && (
        <Box mt={3}>
          {dataLoading ? (
            <h3>Loading risk‐factor data…</h3>
          ) : dataError ? (
            <h3>Error loading data.</h3>
          ) : (
            <RiskFactorShow riskFactorData={riskFactorData} />
          )}
        </Box>
      )}
    </div>
  );

  const intakePanel = (
    <div className="card">
      <Box display="flex" mb={2}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIosIcon fontSize="small" />}
          onClick={handleBack}
          sx={{ textTransform: "none", fontWeight: 500 }}
        >
          Back to Dates
        </Button>
      </Box>
      <RiskFactorIntake
        patient_id={patient_id}
        setSelectedDate={setSelectedDate}
        setIsIntake={setIsIntake}
      />
    </div>
  );

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={6000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {isIntake ? intakePanel : selectPanel}
    </>
  );
};

export default Risks;
